"use client";
import * as React from "react";
const SvgRouteSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M14.22 10.83V0h-7.1v14.22H3.55V5.17a2.7 2.7 0 0 0 1.77-2.5A2.66 2.66 0 0 0 2.67 0 2.66 2.66 0 0 0 0 2.67c0 1.15.75 2.13 1.78 2.5V16h7.1V1.78h3.56v9.05a2.66 2.66 0 0 0 .9 5.17A2.66 2.66 0 0 0 16 13.33c0-1.15-.75-2.13-1.78-2.5" }));
export {
  SvgRouteSharp as default
};
